// Apply SVG polyfill to load external SVG's in unsupported browsers
import 'svgxuse';

import cookies from './modules/cookies/init';
import addClassWhenVisible from './modules/add-class-when-visible';
import tabCards from './modules/tab-cards';
import formValidation from './modules/form/form-validate';
import initFormSteps from './modules/form-steps/init';
import follow from './modules/follow';
import fileInput from './modules/file-input';
import profilePicture from './modules/profile-picture';
import initTabs from './modules/tabs/init';
import timeline from './modules/timeline';
import masonry from './modules/masonry';
import masonryPc from './modules/masonry-pc';
import confirmModal from './modules/modal';
import genericModal from './modules/generic-modal';
import addToHomescreen from './modules/add-to-homescreen';
import userDelete from './modules/user-delete';
import userApprove from './modules/user-approve';
import userPromote from './modules/user-promote';
import userDemote from './modules/user-demote';
import partnerCourses from './modules/partner-courses';
import './polyfills/polyfill-closest';
import './polyfills/polyfill-object-assign';
import './helpers/class-attributes/_class-attributes';
import './modules/menu';
import './modules/scroll-to';
import './modules/birthdate';
import './modules/messages/init';

/**
 * Set in site or modules used config elements
 */
app.config = {
  breakpoints: {
    sm: 30,
    md: 40,
    lg: 60,
    xl: 74,
    hamburger: 60,
  },
  keys: {
    googlemaps: 'AIzaSyC8l0ll7GJuol4X1K6cFugRS3M0blnBdjQ',
    recaptcha: '6Le80NQlAAAAALeMJrbDfCnm-kCxngg_nuzJr0re',
  },
  tabs: {},
};

/**
 * Test some browser options and make them available in app.test
 */
app.test = {
  isEnvironmentIsDev: window.location.host.indexOf('.tdev.team') > -1,
  isEnvironmentIsTest: window.location.host.indexOf('.tdebv.nl') > -1,
  isSessionStorageSupported: require('./tests/is-storage-supported')('session'),
  isLocalStorageSupported: require('./tests/is-storage-supported')('local'),
  isTouchDevice: require('./tests/is-touch-device')(),
  isMobileTabletDevice: require('./tests/is-mobile-tablet')(),
};

/**
 * Add some handy helper functions
 */
app.helper = {
  giveScreenWidth: require('./helpers/screenwidth-in-em'),
  localStorage: require('./helpers/browser-storage')('local'),
  sessionStorage: require('./helpers/browser-storage')('session'),
  setCookie: require('./helpers/cookies/set-cookie'),
  getCookie: require('./helpers/cookies/get-cookie'),
  removeCookie: require('./helpers/cookies/remove-cookie'),
  browser: require('./helpers/browser'),
};

cookies();

if (document.querySelector('[data-whenvisible]')) {
  addClassWhenVisible();
}

if (document.forms.length) {
  formValidation();
}

if (document.querySelector('[data-form-step]')) {
  initFormSteps('[data-form-step]');
}

if (document.querySelector('.js-follow-element')) {
  follow();
}

if (document.querySelector('#js-file-input')) {
  fileInput();
}

if (document.querySelector('.js-profile-picture')) {
  profilePicture();
}

if (document.querySelector('.js-tab-cards')) {
  tabCards();
}

if (document.querySelector('[data-tab]')) {
  initTabs('[data-tab]');
}

if (document.querySelector('.js-timeline')) {
  timeline();
}

if (document.querySelector('.js-confirm-modal')) {
  confirmModal();
}

if (document.querySelector('.js-partner-courses')) {
  partnerCourses();
}

if (document.querySelector('.js-masonry-layout')) {
  masonry();
}

if (document.querySelector('.js-masonry-pc-layout')) {
  masonryPc();
}

if (document.querySelector('.js-discover')) {
  // simpleModal();
}

if (document.querySelector('.js-generic-modal-trigger')) {
  genericModal();
}

if (document.querySelector('.js-user-delete')) {
  userDelete();
}

if (document.querySelector('.js-user-approve')) {
  userApprove();
}

if (document.querySelector('.js-user-promote')) {
  userPromote.init();
}

if (document.querySelector('.js-user-demote')) {
  userDemote.init();
}

addToHomescreen();
